import { render, staticRenderFns } from "./MarriageGenerate.vue?vue&type=template&id=ff86f360&scoped=true&"
import script from "./MarriageGenerate.vue?vue&type=script&lang=js&"
export * from "./MarriageGenerate.vue?vue&type=script&lang=js&"
import style0 from "./MarriageGenerate.vue?vue&type=style&index=0&id=ff86f360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff86f360",
  null
  
)

export default component.exports